
export const CUSTOM_DATA= 'CUSTOM_DATA';
export const CUSTOM_FIELDS = 'CUSTOM_FIELDS';
export const CUSTOM_UPDATE = 'CUSTOM_UPDATE';
export const CUSTOM_TICKET_REQ_MODULE = 'CUSTOM_TICKET_REQ_MODULE';